import Component, { Textarea, setComponentTemplate } from "@ember/component";
import { array, fn } from "@ember/helper";
import { on } from "@ember/modifier";
import { action } from "@ember/object";
import { and, reads } from "@ember/object/computed";
import { service } from "@ember/service";
import { htmlSafe } from "@ember/template";
import { isEmpty } from "@ember/utils";
import { tagName } from "@ember-decorators/component";
import DButton from "discourse/components/d-button";
import PluginOutlet from "discourse/components/plugin-outlet";
import TextField from "discourse/components/text-field";
import basePath from "discourse/helpers/base-path";
import categoryLink from "discourse/helpers/category-link";
import icon from "discourse/helpers/d-icon";
import discourseTag from "discourse/helpers/discourse-tag";
import lazyHash from "discourse/helpers/lazy-hash";
import withEventValue from "discourse/helpers/with-event-value";
import { ajax } from "discourse/lib/ajax";
import { popupAjaxError } from "discourse/lib/ajax-error";
import discourseComputed from "discourse/lib/decorators";
import { i18n } from "discourse-i18n";
import TagChooser from "select-kit/components/tag-chooser";
import { createTemplateFactory } from "@ember/template-factory";
const TagInfo = dt7948.c(class TagInfo extends Component {
  static #_ = (() => dt7948.g(this.prototype, "dialog", [service]))();
  #dialog = (() => (dt7948.i(this, "dialog"), void 0))();
  static #_2 = (() => dt7948.g(this.prototype, "router", [service]))();
  #router = (() => (dt7948.i(this, "router"), void 0))();
  loading = false;
  tagInfo = null;
  newSynonyms = null;
  showEditControls = false;
  editing = false;
  newTagName = null;
  newTagDescription = null;
  static #_3 = (() => dt7948.g(this.prototype, "canAdminTag", [reads("currentUser.staff")]))();
  #canAdminTag = (() => (dt7948.i(this, "canAdminTag"), void 0))();
  static #_4 = (() => dt7948.g(this.prototype, "editSynonymsMode", [and("canAdminTag", "showEditControls")]))();
  #editSynonymsMode = (() => (dt7948.i(this, "editSynonymsMode"), void 0))();
  tagGroupsInfo(tagGroupNames) {
    return i18n("tagging.tag_groups_info", {
      count: tagGroupNames.length,
      tag_groups: tagGroupNames.join(", ")
    });
  }
  static #_5 = (() => dt7948.n(this.prototype, "tagGroupsInfo", [discourseComputed("tagInfo.tag_group_names")]))();
  categoriesInfo(categories) {
    return i18n("tagging.category_restrictions", {
      count: categories.length
    });
  }
  static #_6 = (() => dt7948.n(this.prototype, "categoriesInfo", [discourseComputed("tagInfo.categories")]))();
  nothingToShow(tagGroupNames, categories, synonyms) {
    return isEmpty(tagGroupNames) && isEmpty(categories) && isEmpty(synonyms);
  }
  static #_7 = (() => dt7948.n(this.prototype, "nothingToShow", [discourseComputed("tagInfo.tag_group_names", "tagInfo.categories", "tagInfo.synonyms")]))();
  updateDisabled(newTagName) {
    const filterRegexp = new RegExp(this.site.tags_filter_regexp, "g");
    newTagName = newTagName ? newTagName.replace(filterRegexp, "").trim() : "";
    return newTagName.length === 0;
  }
  static #_8 = (() => dt7948.n(this.prototype, "updateDisabled", [discourseComputed("newTagName")]))();
  didInsertElement() {
    super.didInsertElement(...arguments);
    this.loadTagInfo();
  }
  didUpdateAttrs() {
    super.didUpdateAttrs(...arguments);
    this.set("tagInfo", null);
    this.loadTagInfo();
  }
  loadTagInfo() {
    if (this.loading) {
      return;
    }
    this.set("loading", true);
    return this.store.find("tag-info", this.tag.id).then(result => {
      this.set("tagInfo", result);
      this.set("tagInfo.synonyms", result.synonyms.map(s => this.store.createRecord("tag", s)));
    }).finally(() => this.set("loading", false)).catch(popupAjaxError);
  }
  edit(event) {
    event?.preventDefault();
    this.tagInfo.set("descriptionWithNewLines", this.tagInfo.description?.replaceAll("<br>", "\n"));
    this.setProperties({
      editing: true,
      newTagName: this.tag.id,
      newTagDescription: this.tagInfo.description
    });
  }
  static #_9 = (() => dt7948.n(this.prototype, "edit", [action]))();
  unlinkSynonym(tag, event) {
    event?.preventDefault();
    ajax(`/tag/${this.tagInfo.name}/synonyms/${tag.id}`, {
      type: "DELETE"
    }).then(() => this.tagInfo.synonyms.removeObject(tag)).catch(popupAjaxError);
  }
  static #_10 = (() => dt7948.n(this.prototype, "unlinkSynonym", [action]))();
  deleteSynonym(tag, event) {
    event?.preventDefault();
    this.dialog.yesNoConfirm({
      message: i18n("tagging.delete_synonym_confirm", {
        tag_name: tag.text
      }),
      didConfirm: () => {
        return tag.destroyRecord().then(() => this.tagInfo.synonyms.removeObject(tag)).catch(popupAjaxError);
      }
    });
  }
  static #_11 = (() => dt7948.n(this.prototype, "deleteSynonym", [action]))();
  toggleEditControls() {
    this.toggleProperty("showEditControls");
  }
  static #_12 = (() => dt7948.n(this.prototype, "toggleEditControls", [action]))();
  cancelEditing() {
    this.set("editing", false);
  }
  static #_13 = (() => dt7948.n(this.prototype, "cancelEditing", [action]))();
  finishedEditing() {
    const oldTagName = this.tag.id;
    this.newTagDescription = this.newTagDescription?.replaceAll("\n", "<br>");
    this.tag.update({
      id: this.newTagName,
      description: this.newTagDescription
    }).then(result => {
      this.set("editing", false);
      this.tagInfo.set("description", this.newTagDescription);
      if (result.responseJson.tag && oldTagName !== result.responseJson.tag.id) {
        this.router.transitionTo("tag.show", result.responseJson.tag.id);
      }
    }).catch(popupAjaxError);
  }
  static #_14 = (() => dt7948.n(this.prototype, "finishedEditing", [action]))();
  deleteTag() {
    const numTopics = this.get("list.topic_list.tags.firstObject.topic_count") || 0;
    let confirmText = numTopics === 0 ? i18n("tagging.delete_confirm_no_topics") : i18n("tagging.delete_confirm", {
      count: numTopics
    });
    if (this.tagInfo.synonyms.length > 0) {
      confirmText += " " + i18n("tagging.delete_confirm_synonyms", {
        count: this.tagInfo.synonyms.length
      });
    }
    this.dialog.deleteConfirm({
      message: confirmText,
      didConfirm: async () => {
        try {
          await this.tag.destroyRecord();
          this.router.transitionTo("tags.index");
        } catch {
          this.dialog.alert(i18n("generic_error"));
        }
      }
    });
  }
  static #_15 = (() => dt7948.n(this.prototype, "deleteTag", [action]))();
  addSynonyms() {
    this.dialog.confirm({
      message: htmlSafe(i18n("tagging.add_synonyms_explanation", {
        count: this.newSynonyms.length,
        tag_name: this.tagInfo.name
      })),
      didConfirm: () => {
        return ajax(`/tag/${this.tagInfo.name}/synonyms`, {
          type: "POST",
          data: {
            synonyms: this.newSynonyms
          }
        }).then(response => {
          if (response.success) {
            this.set("newSynonyms", null);
            this.loadTagInfo();
          } else if (response.failed_tags) {
            this.dialog.alert(i18n("tagging.add_synonyms_failed", {
              tag_names: Object.keys(response.failed_tags).join(", ")
            }));
          } else {
            this.dialog.alert(i18n("generic_error"));
          }
        }).catch(popupAjaxError);
      }
    });
  }
  static #_16 = (() => dt7948.n(this.prototype, "addSynonyms", [action]))();
  static #_17 = (() => setComponentTemplate(createTemplateFactory(
  /*
    
      <section class="tag-info">
        {{#if this.tagInfo}}
          <div class="tag-name">
            {{#if this.editing}}
              <div class="edit-tag-wrapper">
                <TextField
                  @id="edit-name"
                  @value={{readonly this.tagInfo.name}}
                  @maxlength={{this.siteSettings.max_tag_length}}
                  @input={{withEventValue (fn (mut this.newTagName))}}
                  @autofocus="true"
                />
  
                <Textarea
                  id="edit-description"
                  @value={{readonly this.tagInfo.descriptionWithNewLines}}
                  placeholder={{i18n "tagging.description"}}
                  maxlength={{1000}}
                  {{on
                    "input"
                    (withEventValue (fn (mut this.newTagDescription)))
                  }}
                  autofocus="true"
                />
  
                <div class="edit-controls">
                  {{#unless this.updateDisabled}}
                    <DButton
                      @action={{this.finishedEditing}}
                      @icon="check"
                      @ariaLabel="tagging.save"
                      class="btn-primary submit-edit"
                    />
                  {{/unless}}
                  <DButton
                    @action={{this.cancelEditing}}
                    @icon="xmark"
                    @ariaLabel="cancel"
                    class="btn-default cancel-edit"
                  />
                </div>
              </div>
            {{else}}
              <div class="tag-name-wrapper">
                {{discourseTag this.tagInfo.name tagName="div"}}
                {{#if this.canAdminTag}}
                  <a
                    href
                    {{on "click" this.edit}}
                    class="edit-tag"
                    title={{i18n "tagging.edit_tag"}}
                  >{{icon "pencil"}}</a>
                {{/if}}
              </div>
              {{#if this.tagInfo.description}}
                <div class="tag-description-wrapper">
                  <span>{{htmlSafe this.tagInfo.description}}</span>
                </div>
              {{/if}}
            {{/if}}
          </div>
          <div class="tag-associations">
            {{~#if this.tagInfo.tag_group_names}}
              {{this.tagGroupsInfo}}
            {{/if~}}
            {{~#if this.tagInfo.categories}}
              {{this.categoriesInfo}}
              <br />
              {{#each this.tagInfo.categories as |category|}}
                {{categoryLink category}}
              {{/each}}
            {{/if~}}
            {{~#if this.nothingToShow}}
              {{#if this.tagInfo.category_restricted}}
                {{i18n "tagging.category_restricted"}}
              {{else}}
                {{htmlSafe (i18n "tagging.default_info")}}
                {{#if this.canAdminTag}}
                  {{htmlSafe (i18n "tagging.staff_info" basePath=(basePath))}}
                {{/if}}
              {{/if}}
            {{/if~}}
          </div>
          {{#if this.tagInfo.synonyms}}
            <div class="synonyms-list">
              <h3>{{i18n "tagging.synonyms"}}</h3>
              <div>{{htmlSafe
                  (i18n
                    "tagging.synonyms_description" base_tag_name=this.tagInfo.name
                  )
                }}</div>
              <div class="tag-list">
                {{#each this.tagInfo.synonyms as |tag|}}
                  <div class="tag-box">
                    {{discourseTag tag.id pmOnly=tag.pmOnly tagName="div"}}
                    {{#if this.editSynonymsMode}}
                      <a
                        href
                        {{on "click" (fn this.unlinkSynonym tag)}}
                        class="unlink-synonym"
                      >
                        {{icon "link-slash" title="tagging.remove_synonym"}}
                      </a>
                      <a
                        href
                        {{on "click" (fn this.deleteSynonym tag)}}
                        class="delete-synonym"
                      >
                        {{icon "trash-can" title="tagging.delete_tag"}}
                      </a>
                    {{/if}}
                  </div>
                {{/each}}
              </div>
            </div>
          {{/if}}
          {{#if this.editSynonymsMode}}
            <section class="add-synonyms field">
              <label for="add-synonyms">{{i18n
                  "tagging.add_synonyms_label"
                }}</label>
              <div class="add-synonyms__controls">
                <TagChooser
                  @id="add-synonyms"
                  @tags={{this.newSynonyms}}
                  @blockedTags={{array this.tagInfo.name}}
                  @everyTag={{true}}
                  @excludeSynonyms={{true}}
                  @excludeHasSynonyms={{true}}
                  @unlimitedTagCount={{true}}
                  @allowCreate={{true}}
                />
                {{#if this.newSynonyms}}
                  <DButton
                    @action={{this.addSynonyms}}
                    @disabled={{this.addSynonymsDisabled}}
                    @icon="check"
                    class="ok"
                  />
                {{/if}}
              </div>
            </section>
          {{/if}}
          {{#if this.canAdminTag}}
            <PluginOutlet
              @name="tag-custom-settings"
              @outletArgs={{lazyHash tag=this.tagInfo}}
              @connectorTagName="section"
            />
  
            <div class="tag-actions">
              <DButton
                @action={{this.toggleEditControls}}
                @icon="gear"
                @label="tagging.edit_synonyms"
                id="edit-synonyms"
                class="btn-default"
              />
              {{#if this.canAdminTag}}
                <DButton
                  @action={{this.deleteTag}}
                  @icon="trash-can"
                  @label="tagging.delete_tag"
                  id="delete-tag"
                  class="btn-danger delete-tag"
                />
              {{/if}}
            </div>
          {{/if}}
        {{/if}}
        {{#if this.loading}}
          <div>{{i18n "loading"}}</div>
        {{/if}}
      </section>
    
  */
  {
    "id": "tKYyM+rW",
    "block": "[[[1,\"\\n    \"],[10,\"section\"],[14,0,\"tag-info\"],[12],[1,\"\\n\"],[41,[30,0,[\"tagInfo\"]],[[[1,\"        \"],[10,0],[14,0,\"tag-name\"],[12],[1,\"\\n\"],[41,[30,0,[\"editing\"]],[[[1,\"            \"],[10,0],[14,0,\"edit-tag-wrapper\"],[12],[1,\"\\n              \"],[8,[32,0],null,[[\"@id\",\"@value\",\"@maxlength\",\"@input\",\"@autofocus\"],[\"edit-name\",[28,[31,1],[[30,0,[\"tagInfo\",\"name\"]]],null],[30,0,[\"siteSettings\",\"max_tag_length\"]],[28,[32,1],[[28,[32,2],[[28,[31,2],[[30,0,[\"newTagName\"]]],null]],null]],null],\"true\"]],null],[1,\"\\n\\n              \"],[8,[32,3],[[24,1,\"edit-description\"],[16,\"placeholder\",[28,[32,4],[\"tagging.description\"],null]],[16,\"maxlength\",1000],[24,\"autofocus\",\"true\"],[4,[32,5],[\"input\",[28,[32,1],[[28,[32,2],[[28,[31,2],[[30,0,[\"newTagDescription\"]]],null]],null]],null]],null]],[[\"@value\"],[[28,[31,1],[[30,0,[\"tagInfo\",\"descriptionWithNewLines\"]]],null]]],null],[1,\"\\n              \"],[10,0],[14,0,\"edit-controls\"],[12],[1,\"\\n\"],[41,[51,[30,0,[\"updateDisabled\"]]],[[[1,\"                  \"],[8,[32,6],[[24,0,\"btn-primary submit-edit\"]],[[\"@action\",\"@icon\",\"@ariaLabel\"],[[30,0,[\"finishedEditing\"]],\"check\",\"tagging.save\"]],null],[1,\"\\n\"]],[]],null],[1,\"                \"],[8,[32,6],[[24,0,\"btn-default cancel-edit\"]],[[\"@action\",\"@icon\",\"@ariaLabel\"],[[30,0,[\"cancelEditing\"]],\"xmark\",\"cancel\"]],null],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],[[[1,\"            \"],[10,0],[14,0,\"tag-name-wrapper\"],[12],[1,\"\\n              \"],[1,[28,[32,7],[[30,0,[\"tagInfo\",\"name\"]]],[[\"tagName\"],[\"div\"]]]],[1,\"\\n\"],[41,[30,0,[\"canAdminTag\"]],[[[1,\"                \"],[11,3],[24,6,\"\"],[24,0,\"edit-tag\"],[16,\"title\",[28,[32,4],[\"tagging.edit_tag\"],null]],[4,[32,5],[\"click\",[30,0,[\"edit\"]]],null],[12],[1,[28,[32,8],[\"pencil\"],null]],[13],[1,\"\\n\"]],[]],null],[1,\"            \"],[13],[1,\"\\n\"],[41,[30,0,[\"tagInfo\",\"description\"]],[[[1,\"              \"],[10,0],[14,0,\"tag-description-wrapper\"],[12],[1,\"\\n                \"],[10,1],[12],[1,[28,[32,9],[[30,0,[\"tagInfo\",\"description\"]]],null]],[13],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null]],[]]],[1,\"        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"tag-associations\"],[12],[41,[30,0,[\"tagInfo\",\"tag_group_names\"]],[[[1,\"            \"],[1,[30,0,[\"tagGroupsInfo\"]]],[1,\"\\n\"]],[]],null],[41,[30,0,[\"tagInfo\",\"categories\"]],[[[1,\"            \"],[1,[30,0,[\"categoriesInfo\"]]],[1,\"\\n            \"],[10,\"br\"],[12],[13],[1,\"\\n\"],[42,[28,[31,5],[[28,[31,5],[[30,0,[\"tagInfo\",\"categories\"]]],null]],null],null,[[[1,\"              \"],[1,[28,[32,10],[[30,1]],null]],[1,\"\\n\"]],[1]],null]],[]],null],[41,[30,0,[\"nothingToShow\"]],[[[41,[30,0,[\"tagInfo\",\"category_restricted\"]],[[[1,\"              \"],[1,[28,[32,4],[\"tagging.category_restricted\"],null]],[1,\"\\n\"]],[]],[[[1,\"              \"],[1,[28,[32,9],[[28,[32,4],[\"tagging.default_info\"],null]],null]],[1,\"\\n\"],[41,[30,0,[\"canAdminTag\"]],[[[1,\"                \"],[1,[28,[32,9],[[28,[32,4],[\"tagging.staff_info\"],[[\"basePath\"],[[28,[32,11],null,null]]]]],null]],[1,\"\\n\"]],[]],null]],[]]]],[]],null],[13],[1,\"\\n\"],[41,[30,0,[\"tagInfo\",\"synonyms\"]],[[[1,\"          \"],[10,0],[14,0,\"synonyms-list\"],[12],[1,\"\\n            \"],[10,\"h3\"],[12],[1,[28,[32,4],[\"tagging.synonyms\"],null]],[13],[1,\"\\n            \"],[10,0],[12],[1,[28,[32,9],[[28,[32,4],[\"tagging.synonyms_description\"],[[\"base_tag_name\"],[[30,0,[\"tagInfo\",\"name\"]]]]]],null]],[13],[1,\"\\n            \"],[10,0],[14,0,\"tag-list\"],[12],[1,\"\\n\"],[42,[28,[31,5],[[28,[31,5],[[30,0,[\"tagInfo\",\"synonyms\"]]],null]],null],null,[[[1,\"                \"],[10,0],[14,0,\"tag-box\"],[12],[1,\"\\n                  \"],[1,[28,[32,7],[[30,2,[\"id\"]]],[[\"pmOnly\",\"tagName\"],[[30,2,[\"pmOnly\"]],\"div\"]]]],[1,\"\\n\"],[41,[30,0,[\"editSynonymsMode\"]],[[[1,\"                    \"],[11,3],[24,6,\"\"],[24,0,\"unlink-synonym\"],[4,[32,5],[\"click\",[28,[32,2],[[30,0,[\"unlinkSynonym\"]],[30,2]],null]],null],[12],[1,\"\\n                      \"],[1,[28,[32,8],[\"link-slash\"],[[\"title\"],[\"tagging.remove_synonym\"]]]],[1,\"\\n                    \"],[13],[1,\"\\n                    \"],[11,3],[24,6,\"\"],[24,0,\"delete-synonym\"],[4,[32,5],[\"click\",[28,[32,2],[[30,0,[\"deleteSynonym\"]],[30,2]],null]],null],[12],[1,\"\\n                      \"],[1,[28,[32,8],[\"trash-can\"],[[\"title\"],[\"tagging.delete_tag\"]]]],[1,\"\\n                    \"],[13],[1,\"\\n\"]],[]],null],[1,\"                \"],[13],[1,\"\\n\"]],[2]],null],[1,\"            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"editSynonymsMode\"]],[[[1,\"          \"],[10,\"section\"],[14,0,\"add-synonyms field\"],[12],[1,\"\\n            \"],[10,\"label\"],[14,\"for\",\"add-synonyms\"],[12],[1,[28,[32,4],[\"tagging.add_synonyms_label\"],null]],[13],[1,\"\\n            \"],[10,0],[14,0,\"add-synonyms__controls\"],[12],[1,\"\\n              \"],[8,[32,12],null,[[\"@id\",\"@tags\",\"@blockedTags\",\"@everyTag\",\"@excludeSynonyms\",\"@excludeHasSynonyms\",\"@unlimitedTagCount\",\"@allowCreate\"],[\"add-synonyms\",[30,0,[\"newSynonyms\"]],[28,[32,13],[[30,0,[\"tagInfo\",\"name\"]]],null],true,true,true,true,true]],null],[1,\"\\n\"],[41,[30,0,[\"newSynonyms\"]],[[[1,\"                \"],[8,[32,6],[[24,0,\"ok\"]],[[\"@action\",\"@disabled\",\"@icon\"],[[30,0,[\"addSynonyms\"]],[30,0,[\"addSynonymsDisabled\"]],\"check\"]],null],[1,\"\\n\"]],[]],null],[1,\"            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"canAdminTag\"]],[[[1,\"          \"],[8,[32,14],null,[[\"@name\",\"@outletArgs\",\"@connectorTagName\"],[\"tag-custom-settings\",[28,[32,15],null,[[\"tag\"],[[30,0,[\"tagInfo\"]]]]],\"section\"]],null],[1,\"\\n\\n          \"],[10,0],[14,0,\"tag-actions\"],[12],[1,\"\\n            \"],[8,[32,6],[[24,1,\"edit-synonyms\"],[24,0,\"btn-default\"]],[[\"@action\",\"@icon\",\"@label\"],[[30,0,[\"toggleEditControls\"]],\"gear\",\"tagging.edit_synonyms\"]],null],[1,\"\\n\"],[41,[30,0,[\"canAdminTag\"]],[[[1,\"              \"],[8,[32,6],[[24,1,\"delete-tag\"],[24,0,\"btn-danger delete-tag\"]],[[\"@action\",\"@icon\",\"@label\"],[[30,0,[\"deleteTag\"]],\"trash-can\",\"tagging.delete_tag\"]],null],[1,\"\\n\"]],[]],null],[1,\"          \"],[13],[1,\"\\n\"]],[]],null]],[]],null],[41,[30,0,[\"loading\"]],[[[1,\"        \"],[10,0],[12],[1,[28,[32,4],[\"loading\"],null]],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n  \"]],[\"category\",\"tag\"],false,[\"if\",\"readonly\",\"mut\",\"unless\",\"each\",\"-track-array\"]]",
    "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/tag-info.js",
    "scope": () => [TextField, withEventValue, fn, Textarea, i18n, on, DButton, discourseTag, icon, htmlSafe, categoryLink, basePath, TagChooser, array, PluginOutlet, lazyHash],
    "isStrictMode": true
  }), this))();
}, [tagName("")]);
export default TagInfo;